/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const segmentCohortRemoteLookupSchema = z.any();

export const segmentCohortRemoteLookupIdSchema = common.objectId;

export const segmentCohortRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string(),
  is_draft: z.boolean(),
  is_archived: z.boolean(),
  is_processed: z.boolean(),
  is_auto_disabled: z.boolean(),
});

export const segmentCohortRemoteLookupFiltersSchema = z.object({});

export const segmentCohortRemoteLookupValidators = {
  id: segmentCohortRemoteLookupIdSchema,
  item: segmentCohortRemoteLookupItemSchema,
  filters: segmentCohortRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 8ae6ecd08bf92875d63158b37a146fee */
